import React from "react";
import styled, { css } from 'styled-components';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  BrowserRouter
} from "react-router-dom";
import About from "./About";
import Home from "./Home";
import Shop from "./Shop";
import Contact from "./Contact";



const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  background: #000000;
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(-100%)'};
  height: 100vh;
  text-align: left;
  padding: 2rem;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-box-shadow: 5px 5px 25px 5px rgba(0,0,0,0.71); 
  box-shadow: 5px 5px 25px 5px rgba(0,0,0,0.71);
  transition: transform 0.9s ease-in-out;

  @media (max-width: 576px) {
      width: 100%;
    }

  a {
    font-size: 2rem;
    text-transform: uppercase;
    padding: 2rem 0;
    font-weight: bold;
    letter-spacing: 0.5rem;
    color: #FFFFFF;
    text-decoration: none;
    transition: color 0.3s linear;

    @media (max-width: 576px) {
      font-size: 1.5rem;
      text-align: center;
    }

    &:hover {
      color: #FFC300;
      animation: menuanim 1s forwards ;
    }

  

    @keyframes menuanim {
        from {
            transform: translate(0,0);
        }
        to {
            transform: translate(1em,0);
        }
      }
  }
`

const Menu = ({ open }) => {
  return (
    
    <StyledMenu open={open}>
      
        
           <a href="/">
        
        Acceuil
        <hr />
      </a>
      
      <a href="https://www.mist-shop.tn">
        
        Nos Produits
        <hr />
      </a>
      <a href="/about">
       
     A propos de Mist
     <hr />
        </a>
      <a href="/contact">
        
        Contact
        <hr />
        </a>

        <h4 className="Copyr">© 2021 Mist. All rights reserved.</h4>
        
  
        
    </StyledMenu>
    
  )
}

const StyledBurger = styled.button`
  position: absolute;
  top: 5%;
  left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;

  &:focus {
    outline: none;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background: ${({ open }) => open ? '#FFFFFF' : '#FFFFFF'};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    :nth-child(2) {
      opacity: ${({ open }) => open ? '0' : '1'};
      transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
    }

    :nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`

const Burger = ({ open, setOpen }) => {
  return (
    <StyledBurger open={open} onClick={() => setOpen(!open)}>
      <div />
      <div />
      <div />
    </StyledBurger>
  )
}


const Bur = () => {
  const [open, setOpen] = React.useState(false);
  const node = React.useRef();
  return (
    <div>
      <div>
        
        
        
       </div>
      <div className="burg" ref={node}>
        <Burger open={open} setOpen={setOpen} />
        <Menu open={open} setOpen={setOpen} />
      </div>
    </div>
  )  
}




const useOnClickOutside = (ref, handler) => {
  React.useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  },
  [ref, handler],
  );
};

export default Bur